<!--
  功能：平台是否适配.适配打勾 不适配打叉
  时间：2025年03月10日 14:52:04
  版本：v1.0
-->
<template>
  <div class="flex items-center">
    <div
      v-for="platform in filteredPlatforms"
      :key="platform.name"
      class="w-4 h-4 relative mr-1"
    >
      <img
        :src="platform.image"
        :alt="platform.name"
      />
      <div class="absolute -right-1 topHalf">
        <p
          class="text-green-600 text-xs text-center"
          v-if="isPlatformAvailable(platformString, platform.name)"
        >
          ✔
        </p>
        <p
          class="text-red-600 text-xs text-center"
          v-else
        >
          X
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const facebook = require('./icon/facebook.png')
const tiktok = require('./icon/tiktok.png')
const snapchat = require('./icon/snapchat.png')
const line = require('./icon/line.png')
const twitter = require('./icon/twitter.png')
const google = require('./icon/google.png')
export default {
  name: 'demo',
  props: {
    platformString: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: 'facebook',
    }
  },
  components: {},
  data() {
    return {
      allPlatforms: [
        { name: 'facebook', image: facebook },
        { name: 'tiktok', image: tiktok },
        { name: 'snapchat', image: snapchat },
        { name: 'line', image: line },
        { name: 'twitter', image: twitter },
        { name: 'google', image: google },
      ],
    };
  },
  computed: {
    filteredPlatforms() {
      const currentPlatform = this.allPlatforms[0];
      const supportedPlatforms = this.platformString ? this.platformString.split(',') : [];
      
      // First try to find supported alternative platform
      let alternativePlatform = this.allPlatforms.find(
        p => p.name !== currentPlatform.name && supportedPlatforms.includes(p.name)
      );
      
      // If no supported alternatives, find any alternative platform
      if (!alternativePlatform) {
        alternativePlatform = this.allPlatforms.find(
          p => p.name !== currentPlatform.name
        );
      }
      
      return alternativePlatform 
        ? [currentPlatform, alternativePlatform]
        : [currentPlatform]; // Fallback if no alternatives exist
    },
  },
  watch: {},
  methods: {
    isPlatformAvailable(availablePlatforms,name) {
      const arr = availablePlatforms ? availablePlatforms.split(',') : []
      return arr.includes(name);
    },
  },
  created() {
    const currentPlatform = this.platform;
    const platformIndex = this.allPlatforms.findIndex(p => p.name === currentPlatform);
    if (platformIndex > 0) {
      const [platform] = this.allPlatforms.splice(platformIndex, 1);
      this.allPlatforms.unshift(platform);
    }
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped lang="scss">
.w-4{
  width: 1rem;
}
.topHalf{
  top: 50%;
}
</style>
